import React, { memo } from 'react';
import {useSelector} from 'react-redux';
import { isNormalZhEnCss } from '../../utils';
import styles from './styles.module.scss';

const Index = memo(() => {
  const { home: {ourAdvantages}, lang } = useSelector(({localesReducer}) => localesReducer.i18n);
  // 样式判断
  const normal = () => {
    return isNormalZhEnCss(lang, 'English') ? styles.normalen : styles.normalcn;
  };

  return (
      <div className={normal()}>
        <div className='content'>
          <div className='row'>
              <p className='title'>{ourAdvantages.title}</p>
              <p className='subTitle'>{ourAdvantages.subTitle}</p>
          </div>
          <div className='info'>
              {
                ourAdvantages.list.map(item => {
                  return (
                    <div key={item.id} className='col'>
                      <div className='innerBg'>
                        <img src={item.img} alt={item.title} />
                      </div>
                      <div className='innerContent'>
                        <div className='num'>{item.id}</div>
                        <p className='innerTitle'>{item.title}</p>
                        <p className='innnrDesc'>{item.desc}</p>
                      </div>
                    </div>
                  )
                })
              }
              
          </div>
        </div>
        <div className='serviceFlow'>
              <div className='flowRow'>
                <p className='title'>{ourAdvantages.flowNums.title}</p>
                <p className='subTitle'>{ourAdvantages.flowNums.subTitle}</p>
              </div>
              <div className='flowCards'>
                <div className='cardBox'>
                  {ourAdvantages.flowNums.list.map(item => (
                    <div key={item.num} className='itemCard'>
                      <div className='innerNum'><span className='itemNum'>{item.num}</span></div>
                      <div className='innerEllipse'>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="6" cy="6" r="6" fill="#FF6D34"/>
                        </svg>
                      </div>
                      <div className='innerIcon'><img src={item.icon} alt={item.name} /></div>
                      <p className='innerText'>{item.name}</p>
                    </div>
                  ))}
                  <div className='innerLine'>
                    <svg width="1590" height="1" viewBox="0 0 1590 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <line y1="0.5" x2="1590" y2="0.5" stroke="black" strokeOpacity="0.2" strokeDasharray="6 6"/>
                    </svg>
                  </div>
                </div>
              </div>
          </div>
      </div>
  );
});
export default Index;
